import type { StaffNotificationRecipientDto } from '@lunary/api-client'

export type StaffEventKey = StaffNotificationRecipientDto['events'][number]
export type StaffScope = StaffNotificationRecipientDto['scope']

export type EventLimits = { staleHours: number; repeatMinutes: number }

export const EVENT_KEYS: readonly StaffEventKey[] = ['new_order', 'client_message', 'upgrade_paid', 'client_closed', 'stale_pending']

export function eventLabel(key: StaffEventKey): string {
  switch (key) {
    case 'new_order':
      return '🔔 Новый разбор'
    case 'client_message':
      return '💬 Сообщения клиента'
    case 'upgrade_paid':
      return '🌕 Переход на консультацию'
    case 'client_closed':
      return '🕊 Клиент завершил разбор'
    case 'stale_pending':
      return '⏳ Разбор долго ждёт ответа'
  }
}

export function eventHint(key: StaffEventKey, limits: EventLimits): string {
  switch (key) {
    case 'new_order':
      return 'Сразу после оплаты заказа: формат и темы, без контактов клиента'
    case 'client_message':
      return `Первое сообщение сразу, следующие одной сводкой не чаще раза в ${limits.repeatMinutes} мин, пока вы не откроете разбор`
    case 'upgrade_paid':
      return 'Клиент доплатил, и разбор стал консультацией'
    case 'client_closed':
      return 'Клиент сам завершил разбор в чате'
    case 'stale_pending':
      return `Один раз, если разбор не взят в работу дольше ${limits.staleHours} ч`
  }
}

export const SCOPE_OPTIONS: ReadonlyArray<{ value: StaffScope; label: string }> = [
  { value: 'all', label: 'Все разборы' },
  { value: 'mine', label: 'Свободные и мои' },
]

export const ROLE_LABELS: Readonly<Record<StaffNotificationRecipientDto['role'], string>> = {
  admin: 'Администратор',
  expert: 'Эксперт',
}
